import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, Icon, SemanticICONS } from 'semantic-ui-react'
import { useNotifier } from '@cbgms/base/notifier'
import Download from '@cbgms/base/utils/download'
import { DashboardSegment } from './DashboardSegment'

interface DashboardDownloadSegmentProps {
  title: string
  subTitle?: string
  icon: SemanticICONS
  downloadAction: () => Promise<Blob>
  fileName: string
}

export const DashboardDownloadSegment: React.FC<DashboardDownloadSegmentProps> = ({ title, subTitle, icon, downloadAction, fileName }) => {
  const [isDownloadingFile, setIsDownloadingFile] = React.useState(false)
  const { t } = useTranslation()
  const notifier = useNotifier()

  const handleClick = async () => {
    try {
      setIsDownloadingFile(true)

      const data = await downloadAction()
      const reader = new FileReader()

      reader.onload = () => {
        if (typeof reader.result === 'string') Download.downloadFileFromText(fileName, reader.result)
      }

      reader.readAsText(data)
    } catch {
      notifier.error(t('global.stats.failed_to_download_order_info'))
    } finally {
      setIsDownloadingFile(false)
    }
  }

  return (
    <Container as='a' className='container-dashboard-home' onClick={handleClick}>
      <DashboardSegment
        color='green'
        icon={icon}
        title={title}
        subTitle={subTitle}
        loading={isDownloadingFile}
        value={
          <Grid.Column className='segment-icon'>
            <Icon name='download' size='large' />
          </Grid.Column>
        }
      />
    </Container>
  )
}
